module.exports = __webpack_public_path__ + "img/morfundee-logo.4f826cb3.png";